import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { NonVotingPartsSummaryDialogComponent } from './annual-declaration-form/non-voting-parts-summary-dialog/non-voting-parts-summary-dialog.component';
import { VotingPartsSummaryDialogComponent } from './annual-declaration-form/voting-parts-summary-dialog/voting-parts-summary-dialog.component';
import { AddButtonComponent } from './shared/add-button/add-button.component';
import { AddressInputComponent } from './shared/address-input/address-input.component';
import { DateInputDialogComponent } from './shared/date-input-dialog/date-input-dialog.component';
import { DateInputComponent } from './shared/date-input/date-input.component';
import { DatedTextInputComponent } from './shared/dated-text-input/dated-text-input.component';
import { DropdownYearsComponent } from './shared/dropdown-years/dropdown-years.component';
import { InputGroupComponent } from './shared/input-group/input-group.component';
import { InputComponent } from './shared/input-group/input/input.component';
import { ResponsiveColPercentDirective } from './shared/input-group/responsive-colPercent-directive ';
import { ResponsiveGutterDirective } from './shared/input-group/responsive-gutter-directive';
import { MemberInputComponent } from './shared/member-input/member-input.component';
import { PercentTextInputComponent } from './shared/percent-text-input/percent-text-input.component';
import { SaveButtonComponent } from './shared/save-button/save-button.component';
import { TextInputComponent } from './shared/text-input/text-input.component';
import { TooltipComponent } from './shared/tooltip/tooltip.component';

@NgModule({
  declarations: [
    TextInputComponent,
    InputGroupComponent,
    InputComponent,
    AddressInputComponent,
    DateInputComponent,
    PercentTextInputComponent,
    DropdownYearsComponent,
    ResponsiveColPercentDirective,
    ResponsiveGutterDirective,
    AddButtonComponent,
    DateInputDialogComponent,
    TooltipComponent,
    SaveButtonComponent,
    TooltipComponent,
    DatedTextInputComponent,
    MemberInputComponent,
    VotingPartsSummaryDialogComponent,
    NonVotingPartsSummaryDialogComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule.forChild(),
    FormsModule
  ],
  exports: [
    TextInputComponent,
    InputGroupComponent, InputComponent,
    AddressInputComponent,
    DateInputComponent,
    PercentTextInputComponent,
    DropdownYearsComponent,
    ResponsiveColPercentDirective,
    ResponsiveGutterDirective,
    AddButtonComponent,
    DateInputDialogComponent,
    TooltipComponent,
    SaveButtonComponent,
    TooltipComponent,
    DatedTextInputComponent,
    MemberInputComponent,
  ],
  providers: [DecimalPipe],
})
export class FormModule { }
